import { signOut } from 'firebase/auth';
import { AuthState } from '../../interface/authState.interface';
import { INITIAL_STATE } from '../../utils/initialize.utils';

export const logout = async (set: any, get: any) => {
    const { firebaseAuth, loginFailure } = get();

    // Start loading
    set((state: AuthState) => ({ ...state, loading: true, errorCode: undefined }));

    const onErrorLogout = (error: any) => {
        loginFailure(error.code);
    };

    signOut(firebaseAuth)
        .then(() => {
            // Sign-out successful.
            set({
                ...INITIAL_STATE,
                firebaseAuth,
                initialLoading: false,
            });
        })
        .catch((error) => {
            onErrorLogout(error);
        });
};
